<template>
  <div class="article-col" :class="colClasses" :style="colStyles">
    <slot />
  </div>
</template>

<script>
export default {
  computed: {
    /**
     * Column classes
     */
    colClasses() {
      return `article-col--h-${this.horizontalAlign}`
    },

    /**
     * Column styles
     */
    colStyles() {
      const styles = {}
      if (this.desktopWidth) {
        styles['--col-width-desktop'] = this.desktopWidth
      }
      if (this.mobileWidth) {
        styles['--col-width-mobile'] = this.mobileWidth
      }

      return styles
    },
  },
  props: {
    /**
     * Desktop column width,
     * in % or px,
     * default: 50%
     */
    desktopWidth: {
      default: '',
      type: String,
    },

    /**
     * Horizontal alignment,
     * default: center
     */
    horizontalAlign: {
      default: 'center',
      type: String,
    },

    /**
     * Mobile column width,
     * in % or px,
     * default: 100%
     */
    mobileWidth: {
      default: '',
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.article-col {
  @apply mx-auto;
}

/* Horizontal alignment */
.article-col.article-col--h-center::v-deep {
  & > h1,
  & > h2,
  & > h3,
  & > h4,
  & > h5,
  & > h6 {
    @apply text-center;
  }
}
.article-col.article-col--h-left::v-deep {
  & > h1,
  & > h2,
  & > h3,
  & > h4,
  & > h5,
  & > h6 {
    @apply text-left;
  }
}
.article-col.article-col--h-right::v-deep {
  & > h1,
  & > h2,
  & > h3,
  & > h4,
  & > h5,
  & > h6 {
    @apply text-right;
  }
}

@screen mobile {
  .article-col {
    width: var(--col-width-mobile, 100%);
  }
}

@screen desktop {
  .article-col {
    width: var(--col-width-desktop, 50%);
    @apply px-5;
  }

  /* Horizontal alignment */
  .article-col.article-col--h-center::v-deep {
    & > .article-cta {
      @apply items-center;
    }
  }
  .article-col.article-col--h-left::v-deep {
    & > .article-cta {
      @apply items-start;
    }
  }
  .article-col.article-col--h-right::v-deep {
    & > .article-cta {
      @apply items-end;
    }
  }
}
</style>
